"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7498],{

/***/ 7498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51071);



var farms = [
    /**
   * These 3 farms (PID 0, 1, 2) should always be at the top of the file.
   */ {
        pid: 0,
        lpSymbol: "CANDY",
        lpAddress: "0x06C04B0AD236e7Ca3B3189b1d049FE80109C7977",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 1,
        lpSymbol: "CANDY-CRO LP",
        lpAddress: "0x1CD85eeFAE1843b1Ae77A3C81bc01f384d0E55b7",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 2,
        lpSymbol: "CANDY-USDT LP",
        lpAddress: "0x50069ffF9d66f1DFC335E554dFC482F458b1C965",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdt */ .R7.usdt
    },
    {
        pid: 3,
        lpSymbol: "CANDY-USDC LP",
        lpAddress: "0x195C982e4014e82c1a6825F1C6b9abA289B15546",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc
    },
    {
        pid: 17,
        lpSymbol: "CANDY-WETH LP",
        lpAddress: "0xD7CeAf41CFEBd5b47310C879b2ac0e4C9e506E43",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.weth */ .R7.weth
    },
    {
        pid: 18,
        lpSymbol: "CANDY-WBTC LP",
        lpAddress: "0x1d0e1c931cF2c31360B51350c2C01716182F19de",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wbtc */ .R7.wbtc
    },
    {
        pid: 48,
        lpSymbol: "CANDY-OLDXTC LP",
        lpAddress: "0x7122E320c616C4dad5eDF789023B1931f6D6f291",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.oldxtc */ .R7.oldxtc
    },
    {
        pid: 49,
        lpSymbol: "CANDY-$XTC LP",
        lpAddress: "0xF5B5D4c063932f9707fa95B58549501B74DdfC50",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.xtc */ .R7.xtc
    },
    {
        pid: 50,
        lpSymbol: "CANDY-BURN LP",
        lpAddress: "0x84bac2e0242f1aef0099f4e05410955fd3a84e6d",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.burn */ .R7.burn
    },
    {
        pid: 51,
        lpSymbol: "$XTC-CRO LP",
        lpAddress: "0x253526207CcC381CC566f899C00D7463c42CffAB",
        boosted: false,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.xtc */ .R7.xtc,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.cro */ .R7.cro
    },
    {
        pid: 42,
        lpSymbol: "CANDY-VERSA LP",
        lpAddress: "0x2454edB8620038206e0ABbc952175ABFc074BCaA",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.versa */ .R7.versa
    },
    {
        pid: 27,
        lpSymbol: "CANDY-ADA LP",
        lpAddress: "0xBC0D3E139cF9001dA7544052EcC3291be03bbC83",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.ada */ .R7.ada
    },
    {
        pid: 28,
        lpSymbol: "CANDY-ATOM LP",
        lpAddress: "0x80e45309f37f29e0E4D0b7B2a3F531E5cfa17fC2",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.atom */ .R7.atom
    },
    {
        pid: 29,
        lpSymbol: "CANDY-SHIB LP",
        lpAddress: "0xD174077Cc3498f50817eE4574270AdC38599550c",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.shib */ .R7.shib
    },
    {
        pid: 30,
        lpSymbol: "CANDY-DOGE LP",
        lpAddress: "0x32DC4a0AECda5a2B382eFe7E0A9AA1dB6016C89E",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.doge */ .R7.doge
    },
    {
        pid: 34,
        lpSymbol: "CANDY-MATIC LP",
        lpAddress: "0x99830edE0f1e08f30Bd9A14f359601b907751ade",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.matic */ .R7.matic
    },
    {
        pid: 35,
        lpSymbol: "CANDY-QNT LP",
        lpAddress: "0x9D4CC3Ed28875727638c4E0cd013CeA09248d247",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.qnt */ .R7.qnt
    },
    {
        pid: 36,
        lpSymbol: "CANDY-ARGO LP",
        lpAddress: "0x9c4C7ECdBEae5eFd36Ba399a3DAAaCaECE0162CC",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.argo */ .R7.argo
    },
    {
        pid: 37,
        lpSymbol: "CANDY-VNO LP",
        lpAddress: "0xf331ad2dcfeef5920246B8B5A82E870F39BB01bc",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.vno */ .R7.vno
    },
    {
        pid: 38,
        lpSymbol: "CANDY-FIRA LP",
        lpAddress: "0xb70d429dee624B725a0a1f83302900eaF6dd3F1a",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.fira */ .R7.fira
    },
    {
        pid: 32,
        lpSymbol: "CANDY-LCRO LP",
        lpAddress: "0x3361b777a5dC02DA8f287f81010dc27BB334A573",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.lcro */ .R7.lcro
    },
    {
        pid: 25,
        lpSymbol: "CANDY-BCRO LP",
        lpAddress: "0x492fFB98235a378fea52683fF69A652beA50B374",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.bcro */ .R7.bcro
    },
    {
        pid: 23,
        lpSymbol: "CANDY-WARZ LP",
        lpAddress: "0x46E5DE27fd3489Af2c9154A60Cc1BcC0c9059392",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.warz */ .R7.warz
    },
    {
        pid: 7,
        lpSymbol: "CANDY-VVS LP",
        lpAddress: "0x6CbaF0B8d91053983AddF0fEeE9117cb2b99e182",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.vvs */ .R7.vvs
    },
    {
        pid: 8,
        lpSymbol: "CANDY-MTD LP",
        lpAddress: "0x3fA42Af308100136B52D6E6092eb11497AEa3563",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.mtd */ .R7.mtd
    },
    {
        pid: 19,
        lpSymbol: "CANDY-CROID LP",
        lpAddress: "0x66F96a69e736Aa110618d51FFd19146653bec0Aa",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.croid */ .R7.croid
    },
    {
        pid: 9,
        lpSymbol: "CANDY-MMF LP",
        lpAddress: "0xa764e7A2366e6a839e986DBCD4e239138E47fDac",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.mmf */ .R7.mmf
    },
    {
        pid: 6,
        lpSymbol: "CANDY-SCRATCH LP",
        lpAddress: "0x9f48298B2f227CC85Fc5f647b39D472cD8c3a129",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.scratch */ .R7.scratch
    },
    {
        pid: 10,
        lpSymbol: "CANDY-TONIC LP",
        lpAddress: "0x86B98AF13802ee6b565BE5F1011fafBc4Cb1209B",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.tonic */ .R7.tonic
    },
    {
        pid: 20,
        lpSymbol: "CANDY-FER LP",
        lpAddress: "0x75655425b267b9fdB087fDD8Fa6c0C07903544fF",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.fer */ .R7.fer
    },
    {
        pid: 21,
        lpSymbol: "CANDY-MIMAS LP",
        lpAddress: "0x29971794Ef33B4CbD870D9B4E8c4f8CD0703387d",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.mimas */ .R7.mimas
    },
    {
        pid: 44,
        lpSymbol: "CANDY-IMP LP",
        lpAddress: "0x99d9f02b01c01BB4eBB5853246cD5355C53088a2",
        boosted: true,
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.imp */ .R7.imp
    },
    {
        pid: 43,
        lpSymbol: "VERSA-USDC LP",
        lpAddress: "0xaE045e68ddE87D37c16bdF5C9eB90FadaDcA7d00",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.versa */ .R7.versa,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc
    },
    {
        pid: 11,
        lpSymbol: "CRO-WBTC LP",
        lpAddress: "0x6C2b0cdB80DB4214E775a89125493c0f232d5891",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wbtc */ .R7.wbtc,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 12,
        lpSymbol: "CRO-WETH LP",
        lpAddress: "0x27367196F4674d3afB871250E67adf2EcaEDF4bc",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.weth */ .R7.weth,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 40,
        lpSymbol: "CRO-USDT LP",
        lpAddress: "0x5340Ee2F6Ca5ff87A836e2804302900F08004DA9",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdt */ .R7.usdt,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 22,
        lpSymbol: "CRO-LINK LP",
        lpAddress: "0x28069BC4e9248c9D9c6F5753bfD94cc4cdeff293",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.link */ .R7.link,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 4,
        lpSymbol: "CRO-USDC LP",
        lpAddress: "0x3091ccE8Ef4f87618852E185e4836a2F43089a67",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 33,
        lpSymbol: "CRO-ATOM LP",
        lpAddress: "0x5f92be847e83309A1ff237292F440353a47eC5D3",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.atom */ .R7.atom,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 45,
        lpSymbol: "CRO-IMP LP",
        lpAddress: "0xAE5B4DD0b7Aa7dA78c7ab0aa37683Ba69cD564a5",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.imp */ .R7.imp,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 46,
        lpSymbol: "USDC-IMP LP",
        lpAddress: "0xD6f3b254cE5Ed3bF769c8677266149729cf11BE2",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.imp */ .R7.imp,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc
    },
    {
        pid: 31,
        lpSymbol: "CRO-LCRO LP",
        lpAddress: "0xC9C3705561e28Bf8032B0f345227C52921C4030D",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.lcro */ .R7.lcro,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 26,
        lpSymbol: "CRO-BCRO LP",
        lpAddress: "0xc79b0e650B0725c49beD898D2BFBdA789aE41487",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.bcro */ .R7.bcro,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro
    },
    {
        pid: 41,
        lpSymbol: "BCRO-ICY LP",
        lpAddress: "0xcCbDAf11BBe2402433592366715232fC52586C26",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.icy */ .R7.icy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.bcro */ .R7.bcro
    },
    {
        pid: 13,
        lpSymbol: "WETH-WBTC LP",
        lpAddress: "0xd8217D6D598998B0056a278FF839DE31542bF76E",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.weth */ .R7.weth,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wbtc */ .R7.wbtc
    },
    {
        pid: 14,
        lpSymbol: "WBTC-USDC LP",
        lpAddress: "0x055e69E19546a2432043f2c7B5885a4E352A9F9B",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wbtc */ .R7.wbtc,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc
    },
    {
        pid: 15,
        lpSymbol: "WETH-USDC LP",
        lpAddress: "0xa749926B852C2C743B11BCe7b7F1F6b5fbb3b65d",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.weth */ .R7.weth,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc
    },
    {
        pid: 16,
        lpSymbol: "USDT-USDC LP",
        lpAddress: "0x19306aDF0Fc931078037Ff130551b867cBb50D2D",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdt */ .R7.usdt,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc
    },
    {
        pid: 39,
        lpSymbol: "CANDY",
        lpAddress: "0x06C04B0AD236e7Ca3B3189b1d049FE80109C7977",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.candy */ .R7.candy,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc,
        isStaking: true,
        boosted: true
    },
    {
        pid: 5,
        lpSymbol: "WCRO",
        lpAddress: "0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.usdc */ .R7.usdc,
        isStaking: true,
        boosted: true
    },
    {
        pid: 24,
        lpSymbol: "WARZ",
        lpAddress: "0x1e942Cc71c28E8440201AbBFCDD0c657fB076BF7",
        token: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.warz */ .R7.warz,
        quoteToken: _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .cronosTokens.wcro */ .R7.wcro,
        isStaking: true
    }, 
].map(function(p) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, p), {
        token: (0,_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .serializeToken */ .Mq)(p.token),
        quoteToken: (0,_pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_0__/* .serializeToken */ .Mq)(p.quoteToken)
    });
});
/* harmony default export */ __webpack_exports__["default"] = (farms);


/***/ })

}]);